/**
 * iter538 · Reviewer Upgrade CTA
 *
 * Renders a giant, unmissable golden "SEE PLANS · UPGRADE" button on
 * the main home screen — but ONLY when the signed-in user is Apple's
 * App Review reviewer account (see /lib/reviewerMode.js).
 *
 * iter546 · Behaviour change (per Jay): previously this button hard-
 * coded a one-tap StoreKit purchase for Athlete Monthly. That satisfied
 * Apple's Guideline 2.1 (subs ≤1 tap from home) but meant reviewers
 * couldn't test other tiers (Agent Solo, Team 10/20/30) or the annual
 * price. It also confused real users testing the reviewer account.
 * The button now opens the full tier-selection paywall modal instead:
 * still ≤1 tap from home (Guideline 2.1 still satisfied), still shows
 * the 7-day free trial for every tier, and the reviewer can pick any
 * product they want.
 *
 * Delete this file + the one call site in App.js `HomeIndex` and the
 * reviewer surface goes back to normal. No other user ever sees this.
 */
import { Sparkles, ArrowRight } from 'lucide-react';
import { useUserAuth } from '../../contexts/UserAuthContext';
import { usePaywall } from '../../contexts/PaywallContext';
import { isReviewerAccount } from '../../lib/reviewerMode';

const ReviewerUpgradeCTA = () => {
  const { user } = useUserAuth();
  const { openPaywall } = usePaywall();

  if (!isReviewerAccount(user)) return null;

  return (
    <div
      className="w-full px-4 pt-4"
      data-testid="reviewer-upgrade-cta-wrapper"
    >
      <button
        type="button"
        onClick={() => openPaywall('bio')}
        className="w-full rounded-2xl overflow-hidden text-black transition active:scale-[0.985]"
        style={{
          background: 'linear-gradient(135deg, #FFD65A 0%, #F5A524 55%, #C77400 100%)',
          boxShadow: '0 12px 32px -12px rgba(245,165,36,0.55), inset 0 1px 0 rgba(255,255,255,0.35)',
          border: '1px solid rgba(255,255,255,0.55)',
        }}
        data-testid="reviewer-upgrade-cta"
      >
        <div className="flex items-center gap-3 px-5 py-5">
          <span
            className="inline-flex items-center justify-center w-11 h-11 rounded-full flex-shrink-0"
            style={{
              background: 'rgba(0,0,0,0.14)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.35)',
            }}
          >
            <Sparkles className="w-5 h-5" strokeWidth={2.6} />
          </span>
          <div className="text-left min-w-0 flex-1">
            <p className="text-[10px] uppercase tracking-[0.32em] font-black leading-none opacity-80">
              Apple Review · Choose Your Plan
            </p>
            <p className="mt-1.5 text-lg font-black tracking-tight leading-none">
              SEE PLANS · UPGRADE
            </p>
            <p className="mt-1 text-[11px] font-semibold opacity-75 leading-tight">
              5 tiers · Monthly or Annual · 7-day free trial
            </p>
          </div>
          <ArrowRight className="w-5 h-5 flex-shrink-0" strokeWidth={3} />
        </div>
      </button>
    </div>
  );
};

export default ReviewerUpgradeCTA;
